<div class="pef-settings-wrapper">
  <table class="pef-settings-table">
    <colgroup>
      <col class="pef-sc-label" />
      <col class="pef-sc-value" />
      <col class="pef-sc-ref" />
      <col class="pef-sc-note" />
    </colgroup>

    <thead>
      <tr class="pef-settings-header">
        <th class="pef-sth pef-sth--label"></th>
        <th class="pef-sth pef-sth--value">{{ valueColumnLabel() }}</th>
        <th class="pef-sth pef-sth--note">Fonte dati</th>
      </tr>
    </thead>

    <tbody>
      @for (row of rows(); track row.id) { @if (row.type === 'spacer') {
      <tr class="pef-settings-spacer">
        <td colspan="3"></td>
      </tr>
      } @else if (row.type === 'section-header') {
      <tr class="pef-settings-section">
        <td class="pef-sd--section-label" colspan="3">{{ row.label }}</td>
      </tr>
      } @else { @let cell = resolveValueCell(row); @let sourceCell =
      resolveSourceCell(row);
      <tr
        class="pef-settings-row"
        [class.pef-sr--total]="row.type === 'total'"
        [class.pef-sr--subtotal]="row.type === 'subtotal'"
        [class.pef-sr--input]="cell.type === 'input'"
        [class.pef-sr--dirty]="isCellDirty(row)"
      >
        <td class="pef-sd pef-sd--label">{{ row.label }}</td>
        <td
          class="pef-sd pef-sd--value"
          [class.pef-sd--input]="cell.type === 'input'"
          [class.pef-sd--calculated]="cell.type === 'calculated'"
        >
          @if (cell.type !== 'empty') {
          <lib-pef-cell
            [cell]="cell"
            [value]="cellValue(row)"
            [loading]="loading()"
            [readonly]="readonly()"
            (valueChange)="cellValueChange.emit($event)"
          />
          }
        </td>
        @if (sourceCell.type !== 'empty') {
        <td
          class="pef-sd pef-sd--value"
          [class.pef-sd--input]="cell.type === 'input'"
          [class.pef-sd--calculated]="cell.type === 'calculated'"
        >
          <lib-pef-cell
            [cell]="sourceCell"
            [value]="cellSourceValue(row)"
            [loading]="loading()"
            [readonly]="readonly()"
            (valueChange)="cellValueChange.emit($event)"
          />
        </td>

        }@else {
        <td class="pef-sd pef-sd--note">{{ row.note ?? '' }}</td>
        }
      </tr>
      } }
    </tbody>
  </table>
</div>
